import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dateFix', standalone: true })
export class DateFixPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      return value.replace(/-/g, '/');
    }
    return value;
  }
}
